import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';
import { CdwIconModule } from '@cdw-ae/common-ui-components-icon';
import { FilterBarComponent } from './filter-bar/filter-bar.component';
import { BaseMatcherEditorComponent } from './matchers/interfaces/base-matcher-editor.component';
import { MatcherEditorDirective } from './matchers/interfaces/matcher-editor.directive';
import { MatcherComponentRegistryService } from './matchers/service/matcher-component-registry.service';
import { FilterBarDialogComponent } from './filter-bar-dialog/filter-bar-dialog.component';
import { FilterBarWrapperComponent } from './filter-bar-wrapper/filter-bar-wrapper.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialLibraryModule,
    CdwIconModule,
  ],
  declarations: [
    FilterBarComponent,
    MatcherEditorDirective,
    BaseMatcherEditorComponent,
    FilterBarDialogComponent,
    FilterBarWrapperComponent,
  ],
  providers: [MatcherComponentRegistryService],
  exports: [
    FilterBarComponent,
    MatcherEditorDirective,
    BaseMatcherEditorComponent,
    FilterBarDialogComponent,
    FilterBarWrapperComponent,
  ],
})
export class FilterBarModule {}
